module.exports = __webpack_public_path__ + "img/icon-10.5b89e9df.png";